import React from "react";
import { Input } from "../../components/Input";
import { parseCapacityInput } from "../utils/eventCapacity";

// How many people can come (GIS-266). Shown to every host, not only admins,
// because it now closes Join once it is reached. One field, or one per group
// on a two-group event. Empty until somebody types a number.
const CapacityInput = ({ size, groupCount, group, onSitterSizeChange, onMoverSizeChange }) => {
  const twoGroups = groupCount === 2;
  const shown = (value) => (value == null ? "" : String(value));

  return (
    <div>
      <div className="flex flex-col sm:flex-row gap-4">
        <Input
          id="capacity-sitters"
          label={twoGroups ? `Capacity: ${group?.sitters || "first group"}` : "Capacity"}
          type="number"
          inputMode="numeric"
          min="1"
          step="1"
          placeholder="How many people can come"
          required={false}
          className="w-full sm:w-64"
          value={shown(size?.sitters)}
          onChange={(e) => onSitterSizeChange(parseCapacityInput(e.target.value))}
        />
        {twoGroups && (
          <Input
            id="capacity-movers"
            label={`Capacity: ${group?.movers || "second group"}`}
            type="number"
            inputMode="numeric"
            min="1"
            step="1"
            placeholder="How many people can come"
            required={false}
            className="w-full sm:w-64"
            value={shown(size?.movers)}
            onChange={(e) => onMoverSizeChange(parseCapacityInput(e.target.value))}
          />
        )}
      </div>
      <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
        Once this many people have RSVP'd, the event shows as full and nobody else can join. You can still add
        guests yourself.
      </p>
    </div>
  );
};

export default CapacityInput;
